export default "__VITE_ASSET__BeHWqr1c__"